<div class="pr">
  <div class="pr-column-box">
    <span style="padding-top: 6px;">
        <label class="toggle-label bold" style="margin-right: 8px;">Show positions with no orders</label>
        <mat-slide-toggle (change)="onShowHidePositions()" [(checked)]="showAllPositions"></mat-slide-toggle>
        <span style="font-size: 20px;padding-left:8px;padding-right: 10px;">|</span>
        @if (expandAllEnabled) {
            <span class="bold"><a (click)="expandAllOrders()">Expand all</a></span>
        } @else {
            <span class="bold" style="color: #8D9AA5;">Expand all</span>
        }
        <span style="color: #98A4AE;">&ensp;|&ensp;</span>
        @if (collapseAllEnabled) {
            <span class="bold"><a (click)="collapseAllOrders()">Collapse all</a></span>
        } @else {
            <span class="bold" style="color: #8D9AA5;">Collapse all</span>
        }
    </span>
    <span>
      <button calltoaction [calltoactionTemplate]="unheldSecurityTemplateRef" calltoactionPosition="right"
              calltoactionMaxWidth="530px" class="btn-medium-secondary" [calltoactionCloseOnOutsideClick]="false"
              [disabled]="!(isPending || isNA) || isAutomated" style="margin-right: 10px;">Buy an unheld security
      </button>
      <span style="font-size: 20px;">&ensp;|&ensp;</span>
      <label style="line-height: 24px;"><span class="swatch userEdit"></span>User-edited order</label>
      <button calltoaction [calltoactionTemplate]="clearUserEditsTemplateRef"
              [calltoactionCloseOnOutsideClick]="false" [disabled]="!(isPending || isNA)  || isAutomated || !hasUserEdits()" class="btn-medium-secondary"
              style="margin-right: 10px;">Undo user edits
      </button>
      <span style="font-size: 20px; line-height: 24px;">&ensp;|&ensp;</span>
      <button calltoaction [calltoactionTemplate]="clearAllOrdersTemplateRef"
              [calltoactionCloseOnOutsideClick]="false" [disabled]="!(isPending || isNA) || isAutomated || !hasOrders()" class="btn-medium-secondary">
        Clear all orders
      </button>
    </span>
    <span style="padding-top: 6px;"><span style="color:#ff0000">W</span>&nbsp;=&nbsp;Wash sale warning</span>
  </div>
  <div class="pr-grid right block" style="width: 100%">
    @if (!isUiTest) {
      <irb-inventory-grid
        [style.width]="'100%'"
        [style.minHeight]="'150px'"
        [style.height]="gridHeight"
        [showSideBar]="false"
        [gridOptions]="gridOptions"
        [componentName]="componentName"
        [rowSelection]="'single'"
        [suppressRowClickSelection] ="false"
        [frameworkComponents]='frameworkComponents'
        [rowData]='unpackedSecRebalDTOList'
        (gridReady)="onGridReady($event)"
        [popupParent]="popupParent"
        (columnVisible) = 'onColumnVisible($event)'></irb-inventory-grid>
    }
    <div style="display:flex">
      <div>
        <div class="note hblock">If you have VSP instructions enabled, tax lot selections won't be used for mutual fund
          sales
          done in dollars, sales done in average cost accounts, or option trades.
        </div>

        <div class="note block">* Positions are excluded from the rebalance (options, short positions or excluded
          restriction
          type).
        </div>
      </div>
      <div style="margin-left: auto;order: 2;">
        <div class="ag-primary-cols-reset-header-panel" (click)="resetGridColumns()">
          <div class="resetIcon"></div>
          <div class="resetText">Reset columns</div>
        </div>
      </div>
    </div>

  </div>

  <irb-common-dialog #dialogPrComOrders></irb-common-dialog>
</div>

<ng-template #clearAllOrdersTemplateRef>
  <div class="block">Clear all Orders? This will clear both user-edits and original orders identified by iRebal.</div>
  <div class="buttonSet">
    <button class="btn-medium-secondary" (click)="cancelCallToAction()">Cancel</button>
    <button class="btn-medium-primary" (click)="clearAllOrders()">Clear All</button>
  </div>
</ng-template>

<ng-template #clearUserEditsTemplateRef>
  <div class="block">Clear all user-edits and revert to original orders identified by iRebal?</div>
  <div class="buttonSet">
    <button class="btn-medium-secondary" (click)="cancelCallToAction()">Cancel</button>
    <button class="btn-medium-primary" (click)="clearAllUserEdits()">Clear All</button>
  </div>
</ng-template>

<ng-template #unheldSecurityTemplateRef>
  <div id='buyUnheldContent' class='allocTooltipHeader' style='width: 100%;'>
    <div id='mainStatusMessage' class='statusMessage error' style='display: none;float:left;width:100%'></div>
    <div style='width:100%; height:25px;font-weight:bold;'>
      <span style='float:left;width:210px;'>Symb</span>
      <span style='float:left;width:130px;padding:0 5px;'>Description</span>
    </div>
    <div style='width:100%; height:35px'>
      <div style='float:left;width:210px;' id='slctSecurityTypeDiv'>
        <irb-dropdown-search #unheldSecuritySymbolDropdown  [(value)]="unheldSecurityOption" (search)="populateUnheldSymbols($event)"
                             (selection)="setUnheldSecurity()" size="16" hoverPanelZIndex="1000004"
                             (clearSelection)="clearUnheldSecurity()"  autoFocus="true"
        ></irb-dropdown-search>
      </div>
      <div style='float:left;width:300px;padding:0 5px;overflow:hidden;text-overflow:ellipsis;white-space:pre;'
           id='secDescDiv'>{{unheldSecurityOption?.value.securityDescription}}</div>
    </div>
    <div style='width:100%; height:25px; font-weight:bold;'>
      <span style='float:left; width:195px;'>Order amt</span>
    </div>
    <div style='height:35px;'>
            <span style='display: inline-block;width:195px;'>
                     <!--<irb-validation-text-box #unheldSecurityOrderField [(value)]="unheldSecurityOrderAmt"
                                         (blur)="setUnheldSecurity()"
                                         regExp="\-?[$]?\(?\-?(0|[1-9]([0-9]+)?)?(\.[0-9]{0,2})?\)?"
                                         invalidMessage="Invalid input."
                                         width="178px" prefix="$"></irb-validation-text-box>    -->          
                                         <irb-number-text-box #unheldSecurityOrderField
                                         [(value)]="unheldSecurityOrderAmt"
                                         (valueChange)="enableDisableButton()"
                                         (focusout)="setUnheldSecurity()"
                                         [min]="0"
                                         [max]="999999999"
                                         [places]="2"
                                         [isCurrency]="true"
                                         [isPercentage]="false"
                                         [isNegative]="false"
                                         [isBold]="false"
                                         [isNotApplicable]="false"
                                         [rounding]="false"
                                         invalidRangeMessage="Invalid input"
                                         width="178px"
                                         ></irb-number-text-box>                                          
            </span>
    </div>
    <div style='width:100%;margin:3px 0;height:20px;font-weight:bold;'>Account#</div>
    <div style='width:100%; height:25px'>
      <irb-dropdown-filter #unheldAccountDropdown [(value)]="unheldSecurityAccountOption" (search)="populateUnheldAccounts($event)" (selection)="setUnheldSecurity()" size="60" hoverPanelZIndex="1000004" [hoverPanelWidth]="400" ></irb-dropdown-filter>
    </div>
  </div>
  <input id='txnCurrency' type='hidden'/><br class='clear'/>
  <div class="buttonSet">
    <button class="btn-medium-secondary" (click)="closeUnheldSecurityPopover()">Cancel</button>
    <button class="btn-medium-primary" [disabled]="addUnheldSecurityDisabled" (click)="addUnheldSecurity()">
      OK
    </button>
  </div>
</ng-template>
<ng-template #comPrOrderTemplate>
  <span [innerHTML]="comPrOrderTemplateContent"></span>
</ng-template>
<ng-template #securityTradeActionNoteTemplate>
  <span [innerHTML]="securityTradeActionNoteTemplateContent"></span>
</ng-template>

